<!-- AnnouncementModal.vue -->
<template>
  <div class="modal-container">
    <img
      src="images/close.svg"
      class="close"
      @click="resetModal"
      role="button"
      aria-label="Close"
      alt="X to close modal"
      title="Close"
    />
    <div class="modal-content">
      <transition-group :name="titleFade">
        <h2 :key="title">{{ title }}</h2>
      </transition-group>
      <div class="modal-main">
        <knot-carousel
          :selected-slide="selectedSlide"
          @page-changed="pageChange"
        >
          <template
            v-for="(value, index) in announcements"
            v-slot:[index]
            :key="index"
          >
            <h2 class="centered-text">{{ value.header }}</h2>
            <div class="centered-text body" v-html="marked(value.body)"></div>
            <button @click="dismiss(value.id)" class="single-button">Dismiss</button>
          </template>
        </knot-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import { marked } from "marked";
import DOMPurify from "dompurify";

export default {
  name: "HelpModal",
  props: {
    resetModal: {
      type: Function,
      required: true,
    },
    announcements: {
      type: Array,
      required: true,
    },
    selectedSlide: {
      type: String,
    },
  },
  data() {
    return {
      defaultTitle: "Announcements",
      title: null,
      titleFade: null,
    };
  },
  created() {
    this.title = this.defaultTitle;
  },
  watch: {
    announcements: {
      handler: function (newValue) {
        if (newValue.length === 0) {
          this.resetModal()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {},
  methods: {
    pageChange(newPageIndex, oldPageIndex, behavior) {
      // this.title = this.announcements[newPageIndex].header
      if (behavior === "smooth") {
        this.titleFade =
          oldPageIndex < newPageIndex ? "move-right-fade" : "move-left-fade";
      } else {
        this.titleFade = null;
      }
    },
    marked(markdown) {
      const html = marked(markdown)
      return DOMPurify.sanitize(html);
    },
    dismiss(id) {
      this.$emit("dismiss", id);
    }
  },
};
</script>

<style scoped>
h2 {
  color: var(--red-herring-color);
  text-align: center;
  margin: 0 2vh 2vh;
}
button {
  align-self: center;
  font-size: 2vh;
  margin-top: 2vh;
}
.body {
  gap: 1vh;
  display: flex;
  flex-direction: column;
}
</style>